import React from 'react';
import { WhiskIcon } from './icons/WhiskIcon';

function Header() {
  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="relative">
              <div className="absolute -inset-2 bg-primary/20 rounded-full blur-lg animate-pulse"></div>
              <WhiskIcon className="w-12 h-12 text-primary relative hover:scale-110 transition-transform" />
            </div>
            <div>
              <h1 className="text-2xl font-heading bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent">
                WiskWiz
              </h1>
              <div className="flex flex-col">
                <p className="text-sm text-text-light">Your AI Baking Assistant</p>
                <a 
                  href="https://brownieheaven.co.uk" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-[10px] text-primary hover:text-primary/80 transition-colors"
                >
                  by Brownie Heaven
                </a>
              </div>
            </div>
          </div>
          <div className="hidden sm:block">
            <div className="flex items-center gap-2 text-sm text-text-light">
              <span className="w-2 h-2 bg-primary rounded-full animate-pulse"></span>
              AI Powered Recipes
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;